module.exports = __webpack_public_path__ + "img/7875a4318100a48858851b051733b5f5.png";